import {
  anxietyMatcherRegexp,
  depressionMatcherRegexp,
  socialAnxietyMatcherRegexp,
} from '@lib/utilities/conditionMatcherRegexp'

type WhyApplyStory = {
  whyApplyPatientAddress: string
  whyApplyPatientAge: number
  whyApplyPatientName: string
  whyApplyStory: string
}

/**
 * Retrieves a "Why Apply" story for a given condition name.
 * The story includes anonymized patient details and their reason for applying to a clinical trial.
 *
 * The function matches the condition name against predefined regular expressions for depression,
 * social anxiety, and anxiety. If no match is found, a default story is returned.
 */
export function getWhyApplyStoryForCondition({
  conditionName,
}: {
  conditionName: string
}): WhyApplyStory {
  if (depressionMatcherRegexp.test(conditionName.trim())) {
    return {
      whyApplyPatientAddress: 'San Francisco, CA',
      whyApplyPatientAge: 52,
      whyApplyPatientName: 'A.S.',
      whyApplyStory: `“I’ve struggled with depression for as long as I can remember. I’ve tried various drugs with little discernible effect. I don’t want to live being controlled by it any longer.”`,
    }
  } else if (socialAnxietyMatcherRegexp.test(conditionName.trim())) {
    return {
      whyApplyPatientAddress: 'Dallas, TX',
      whyApplyPatientAge: 44,
      whyApplyPatientName: 'H.G.',
      whyApplyStory: `“I have tried a couple of different medications but none seemed to help. When I saw this clinical trail I saw this as a bit of hope.”`,
    }
  } else if (anxietyMatcherRegexp.test(conditionName.trim())) {
    return {
      whyApplyPatientAddress: 'Atlanta, GA',
      whyApplyPatientAge: 43,
      whyApplyPatientName: 'M.C.',
      whyApplyStory: `“My current anxiety treatment is not completely effective and it’s important to me to try to help find an effective treatment so others don’t have to suffer in the future.”`,
    }
  } else {
    return {
      whyApplyPatientAddress: 'New York, NY',
      whyApplyPatientAge: 47,
      whyApplyPatientName: 'S.B.',
      whyApplyStory: `“Some medicines have helped, while others haven’t. However, I feel there is something out there that will help to a greater degree.”`,
    }
  }
}
